export enum Departmentmode {
  List,
  TaskCount,
}
